module.exports = __webpack_public_path__ + "img/user.e8a46b83.svg";